module.exports = __webpack_public_path__ + "media/icons/select_all-46265478.png";